<template>
  <dashboard-widget
    :id="widgetType"
    :heading="$t(`seo_service.${translationPath}.title`)"
  >
    <template slot="explanation">
      <div class="is-size-5">
        {{ $t(`seo_service.${translationPath}.text`) }}
      </div>
    </template>
    <div>
      <spinner
        v-if="$apollo.queries.data.loading && !browserSupportsFilters"
        :offset-top="heightOfWidgetTopBar"
      />
      <data-placeholder v-if="data && data[widgetType] == null" />
      <component
        :is="component"
        v-else
        :data="data && data[widgetType]"
        :loading="$apollo.queries.data.loading"
        :supports-blur="browserSupportsFilters"
      />
    </div>
  </dashboard-widget>
</template>

<script>
import modernizr from 'modernizr'
import DashboardWidget from '@/components/Shared/DashboardWidget'
import GET_LAST_REPORT from '@/graphql/GET_LAST_REPORT.gql'
import DataPlaceholder from '@/components/Shared/DataPlaceholder'
import Spinner from '@/components/Shared/Spinner'
import BasePerformanceScore from './BasePerformanceScore'
import BaseIndexedPages from './BaseIndexedPages'
import BaseWebsiteAuthority from './BaseWebsiteAuthority'
import BaseLinkingSites from './BaseLinkingSites'
import BaseInboundLinks from './BaseInboundLinks'
import BaseFullRankingReport from './BaseFullRankingReport'
import BaseHistoricalRankingReport from './BaseHistoricalRankingReport'
import BaseRankChangeAllKeywords from './BaseRankChangeAllKeywords'
import BaseRankChangeByGoogleEngine from './BaseRankChangeByGoogleEngine'

export default {
  name: 'WidgetContainer',

  components: {
    DashboardWidget,
    DataPlaceholder,
    Spinner,
    BasePerformanceScore,
    BaseIndexedPages,
    BaseWebsiteAuthority,
    BaseLinkingSites,
    BaseInboundLinks,
    BaseFullRankingReport,
    BaseHistoricalRankingReport,
    BaseRankChangeAllKeywords,
    BaseRankChangeByGoogleEngine
  },

  props: {
    date: {
      type: String,
      default: null
    },
    widgetType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      component: null,
      translationPath: null,
      heightOfWidgetTopBar: '39px'

    }
  },

  computed: {
    browserSupportsFilters () {
      return modernizr.cssfilters
    }
  },

  created () {
    switch (this.widgetType) {
      case ('performanceScore'):
        this.translationPath = 'perf_score'
        this.component = BasePerformanceScore
        break
      case ('websiteAuthority'):
        this.translationPath = 'web_authority'
        this.component = BaseWebsiteAuthority
        break
      case ('websitePagesIndexed'):
        this.translationPath = 'indexed_pages'
        this.component = BaseIndexedPages
        break
      case ('linkingWebsites'):
        this.translationPath = 'linking_sites'
        this.component = BaseLinkingSites
        break
      case ('inboundLinks'):
        this.translationPath = 'inbound_links'
        this.component = BaseInboundLinks
        break
      case ('fullRankingReport'):
        this.translationPath = 'full_rank'
        this.component = BaseFullRankingReport
        break
      case ('historicalRankings'):
        this.translationPath = 'historical_rank'
        this.component = BaseHistoricalRankingReport
        break
      case ('rankingChangeAllKeywords'):
        this.translationPath = 'rank_change_all'
        this.component = BaseRankChangeAllKeywords
        break
      case ('rankingChangeByGoogleEngine'):
        this.translationPath = 'rank_change_google'
        this.component = BaseRankChangeByGoogleEngine
        break
      default:
        return BasePerformanceScore
    }
  },

  apollo: {
    data: {
      query: GET_LAST_REPORT,
      variables () {
        return {
          seoId: this.$route.params.serviceId,
          date: this.date
        }
      },
      update: data => data.getSEOReportByDate.result
    }
  }
}
</script>
